import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../../utils/ga';

export default function GAListener() {
  const location = useLocation();

  useEffect(() => {
    trackPageview();
  }, [location.pathname, location.search]);

  return null;
}
